import React, { Component } from "react";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Icon } from "@iconify/react";
import { withNamespaces } from "react-i18next";

import MobileSubHeader from "../../../components/PageHeader/MobileSubHeader";

export class EditLoginPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOldPwd: false,
      showNewPwd: false,
      showConfirmPwd: false,
    };
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;
    
    const ChangePasswordSchema = Yup.object().shape({
      current_password: Yup.string()
          .min(6, t("validation.minLength", { 0: 6 }))
          .max(20, t("validation.maxLength", { 0: 20 }))
          .required(t("validation.required")),
      new_password: Yup.string()
          .min(6, t("validation.minLength", { 0: 6 }))
          .max(20, t("validation.maxLength", { 0: 20 }))
          .required(t("validation.required")),
      confirm_password: Yup.string()
          .min(6, t("validation.minLength", { 0: 6 }))
          .max(20, t("validation.maxLength", { 0: 20 }))
          .required(t("validation.required"))
          .when("new_password", {
              is: (val) => (val && val.length > 0 ? true : false),
              then: Yup.string().oneOf([Yup.ref("new_password")], t("validation.confirm-password-not-match-with-new-password")),
          }),
  });

    const img = this.imageImport(
      require.context("../../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/)
    );
    return (
      <section className="verification-m-section pf-m-dashboard on-top d-block pe-auto">
        <MobileSubHeader
          className="bg-white"
          closeModalHandler={this.props.backToPersonalDetails}
          header={t("personal-details.edit-login-password")}
          style={{ justifyContent: "unset" }}
        />
        <Formik
          innerRef={(p) => (this.formik = p)}
          initialValues={{
            current_password: "",
            new_password: "",
            confirm_password: "",
            pwdStrength: "low",
          }}
          validationSchema={ChangePasswordSchema}
          validate={(values) => {
            if (values.new_password) {
              const mediumRegex = new RegExp(
                "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
              );
              const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&])(?=.{8,})");
              if (strongRegex.test(values.new_password)) {
                values.pwdStrength = "strong";
              } else if (mediumRegex.test(values.new_password)) {
                values.pwdStrength = "normal";
              } else if (!mediumRegex.test(values.new_password) && !strongRegex.test(values.new_password)) {
                values.pwdStrength = "low";
              }
            }
          }}
          onSubmit={(values, actions) => {
            this.props.updateLoginPasswordHandler(values, actions);
          }}
        >
          {({ errors, touched, values }) => (
            <Form
              className="forms-col my-3"
              // method="post"
              name="change_password_from"
              id="change_password_from"
              // onSubmit={this.props.updateLoginPasswordHandler}
              noValidate
            >
              <div className="pd-form-m-col">
                <div className="input-group-col">
                  {/* <ValidationError formName="change_password_from" touched={this.props.touched} message={this.props.error_message} /> */}
                  <div className="py-2">
                    <label className="col-form-label lh-1 p-0 m-0 text-dark">{t("profile.old-password")}</label>
                    <div className="input-group right has-validation">
                      {this.props.errorMsg.current_password || touched.current_password ? (
                      <Field
                        name="current_password"
                        type={`${this.state.showOldPwd ? "text" : "password"}`}
                        className={`form-control ${
                          this.props.errorMsg.current_password ||
                          (touched.current_password && errors.current_password)
                            ? `is-invalid`
                            : `is-valid`
                        }`}
                        minLength="8"
                        maxLength="15"
                        onKeyUp={(e) => this.props.enterLoginOldPass(e)}
                      />
                    ) : (
                      <Field
                        name="current_password"
                        type="password"
                        className={`form-control`}
                        minLength="8"
                        maxLength="15"
                      />
                    )}

                      <span
                        className="input-group-text"
                        onClick={() => this.setState({ showOldPwd: !this.state.showOldPwd })}
                      >
                        <button type="button" className="btn icon">
                          {this.state.showOldPwd ? (
                            <img src={img["eye.png"]} alt="show pwd" />
                          ) : (
                            <img src={img["close-eye.png"]} alt="hide pwd" />
                          )}
                        </button>
                      </span>
                      {(this.props.errorMsg.current_password ||
                      (touched.current_password && errors.current_password)) && (
                      <div className="invalid-feedback">
                        {errors.current_password
                          ? errors.current_password
                          : this.props.errorMsg.current_password}
                      </div>
                    )}
                    </div>
                  </div>
                  <div className="py-2 border-top">
                    <div className="d-flex align-items-center">
                      <label className="col-form-label lh-1 p-0 m-0 text-dark">{t("profile.new-password")}</label>
                      <div className="pi-sec-lvl-col ms-3">
                        <div className="pi-sec-lvl-content ">
                          <div className={`pi-sec-lvl-bar ${values.pwdStrength} sec-m-lvl`}>
                            <p>
                              {values.pwdStrength === "low"
                                ? t("register.low")
                                : values.pwdStrength === "normal"
                                ? t("register.normal")
                                : t("register.strong")}
                            </p>
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="input-group right has-validation">
                      {this.props.errorMsg.new_password || touched.new_password ? (
                      <Field
                        name="new_password"
                        type={`${this.state.showNewPwd ? "text" : "password"}`}
                        className={`form-control ${
                          this.props.errorMsg.new_password || (touched.new_password && errors.new_password)
                            ? `is-invalid`
                            : `is-valid`
                        }`}
                        minLength="8"
                        maxLength="15"
                        onKeyUp={(e) => this.props.enterLoginNewPass(e)}
                      />
                    ) : (
                      <Field
                        name="new_password"
                        type="password"
                        className={`form-control`}
                        minLength="8"
                        maxLength="15"
                      />
                    )}

                      <span
                        className="input-group-text"
                        onClick={() => this.setState({ showNewPwd: !this.state.showNewPwd })}
                      >
                        <button type="button" className="btn icon">
                          {this.state.showNewPwd ? (
                            <img src={img["eye.png"]} alt="show pwd" />
                          ) : (
                            <img src={img["close-eye.png"]} alt="hide pwd" />
                          )}
                        </button>
                      </span>
                      {(this.props.errorMsg.new_password || (touched.new_password && errors.new_password)) && (
                      <div className="invalid-feedback">
                        {errors.new_password ? errors.new_password : this.props.errorMsg.new_password}
                      </div>
                    )}
                    </div>
                  </div>
                  <div className="py-2 border-top">
                    <label className="col-form-label lh-1 p-0 m-0 text-dark">{t("profile.confirm-password")}</label>
                    <div className="input-group right has-validation">
                      {this.props.errorMsg.confirm_password || touched.confirm_password ? (
                      <Field
                        name="confirm_password"
                        type={`${this.state.showConfirmPwd ? "text" : "password"}`}
                        className={`form-control ${
                          this.props.errorMsg.confirm_password ||
                          (touched.confirm_password && errors.confirm_password)
                            ? `is-invalid`
                            : `is-valid`
                        }`}
                        minLength="8"
                        maxLength="15"
                        onKeyUp={(e) => this.props.enterLoginConfirmPass(e)}
                      />
                    ) : (
                      <Field
                        name="confirm_password"
                        type="password"
                        className={`form-control`}
                        minLength="8"
                        maxLength="15"
                      />
                    )}

                      <span
                        className="input-group-text"
                        onClick={() => this.setState({ showConfirmPwd: !this.state.showConfirmPwd })}
                      >
                        <button type="button" className="btn icon">
                          {this.state.showConfirmPwd ? (
                            <img src={img["eye.png"]} alt="show pwd" />
                          ) : (
                            <img src={img["close-eye.png"]} alt="hide pwd" />
                          )}
                        </button>
                      </span>
                      {(this.props.errorMsg.confirm_password ||
                      (touched.confirm_password && errors.confirm_password)) && (
                      <div className="invalid-feedback">
                        {errors.confirm_password
                          ? errors.confirm_password
                          : this.props.errorMsg.confirm_password}
                      </div>
                    )}
                    </div>
                  </div>
                </div>
                <button className="btn btn-gradient-blue mx-3" type="submit" value="Submit">
                  {t("global.submit")}
                </button>
                {/* <p className="sp-mention">
                                              {t("profile.verification-mention-1")} &nbsp;
                                              <Link to={{ pathname: "/" }}> {t("global.customer-service")}</Link>
                                              &nbsp;  {t("profile.verification-mention-2")}
                                          </p> */}
              </div>
            </Form>
          )}
        </Formik>
      </section>
    );
  }
}

export default withNamespaces()(EditLoginPassword);
